import Header from './header';

export default class DetailProfileHeader {
  public static header: Header[] = [
    {
      text: 'Title',
      align: 'start',
      sortable: true,
      value: 'title',
      class: 'truncate',
      width: ''
    },
    // {
    //   text: 'Short Name',
    //   align: 'start',
    //   sortable: true,
    //   value: 'shortName',
    //   class: 'truncate',
    //   width: '20%'
    // },
    {
      text: 'Detail',
      align: 'right',
      value: 'actions',
      sortable: false,
      class: null,
      width: '5%'
    }
  ];
}
